import * as React from "react";

const Macro = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer3"
      fill="none"
      stroke="#000"
      strokeDasharray="none"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <path
        id="path8"
        d="m1.992 4.366-1.13-1.13a.273.273 0 0 1 0-.386l1.13-1.13m2.646 2.646 1.13-1.13a.273.273 0 0 0 0-.386l-1.13-1.13"
        opacity="1"
        transform="translate(-.14 .132)"
      ></path>
      <path id="path9" d="m2.646 4.762 1.058-3.175" opacity="1"></path>
    </g>
  </svg>
);

export default Macro;
